module.exports = __webpack_public_path__ + "img/icon-new.2e5b60a6.svg";